/*
 * Add-to-cart buttons rendered by the atc-button snippet.
 * Delegated from the document so any section can use it, including markup
 * injected after load (product recommendations, theme editor re-renders).
 */
(function () {
  var MIN = 1;
  var MAX = 999;

  function qtyInput(group) {
    return group ? group.querySelector('[js-atc-qty]') : null;
  }

  function readQty(group) {
    var input = qtyInput(group);
    if (!input) return 1;
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < MIN) n = MIN;
    if (n > MAX) n = MAX;
    return n;
  }

  function setQty(group, n) {
    var input = qtyInput(group);
    if (!input) return;
    if (n < MIN) n = MIN;
    if (n > MAX) n = MAX;
    input.value = n;
  }

  function refreshCartCount() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('[js-cart-num]').forEach(function (el) {
          el.innerHTML = cart.item_count;
        });
      })
      .catch(function () { /* the count is cosmetic; ignore */ });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[js-atc-minus]');
    var plus = e.target.closest('[js-atc-plus]');
    var button = e.target.closest('[js-atc]');

    if (minus) {
      e.preventDefault();
      var g1 = minus.closest('[js-atc-group]');
      setQty(g1, readQty(g1) - 1);
      return;
    }

    if (plus) {
      e.preventDefault();
      var g2 = plus.closest('[js-atc-group]');
      setQty(g2, readQty(g2) + 1);
      return;
    }

    if (!button || button.disabled) return;
    e.preventDefault();

    var group = button.closest('[js-atc-group]');
    var id = Number(button.getAttribute('data-variant-id'));
    if (!id) return;

    var label = button.textContent;
    button.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: id, quantity: readQty(group) })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed: ' + res.status);
        return res.json();
      })
      .then(function () { return refreshCartCount(); })
      .catch(function (err) { console.error(err); })
      .then(function () {
        button.disabled = false;
        button.textContent = label;
      });
  });

  // keep the field numeric as it is typed
  document.addEventListener('input', function (e) {
    var input = e.target.closest('[js-atc-qty]');
    if (!input) return;
    input.value = input.value.replace(/[^0-9]/g, '');
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[js-atc-qty]');
    if (!input) return;
    setQty(input.closest('[js-atc-group]'), readQty(input.closest('[js-atc-group]')));
  });
})();
